import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { auth } from './firebase';
import './App.css';

import UsersList from './components/UsersList';
import Login from './components/Login';
import SurveyBuilder from './components/SurveyBuilder'; // <-- Import the new screen
import CreateSurvey from './components/CreateSurvey'; 

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((firebaseUser) => {
      setUser(firebaseUser);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Router>
      <div className="App">
        <header className="bg-white border-b border-gray-200">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between h-20">
              <div className="flex items-center">
                <img 
                  src="/logo-starkey.svg"
                  alt="Starkey Logo" 
                  className="h-12 w-auto"
                />
                <h1 className="ml-8 text-3xl font-bold text-gray-900 tracking-tight">EMA</h1>
              </div>
              {user && (
                <div className="flex items-center space-x-4">
                  <span className="text-sm text-gray-500">Welcome,</span>
                  <span className="text-sm font-medium text-gray-900">{user.email}</span>
                </div>
              )}
            </div>
          </div>
        </header>

        <main className="bg-gray-50 min-h-screen">
          <Routes>
            <Route
              path="/"
              element={user ? <UsersList user={user} /> : <Navigate to="/login" />}
            />
            <Route
              path="/survey-builder"
              element={user ? <SurveyBuilder documentId={user.uid} /> : <Navigate to="/login" />}
            />
            <Route
              path="/create-survey"
              element={user ? <CreateSurvey /> : <Navigate to="/login" />}
            />
            <Route path="/login" element={<Login />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
